import { LocalFormActionTypes } from "./form.types";

const INITIAL_STATE = {};

const LocalFormReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case LocalFormActionTypes.RESET_LOCAL_FORM:
      return {};

    case LocalFormActionTypes.MODIFY_LOCAL_FORM:
      return action.payload;

    default:
      return state;
  }
};

export default LocalFormReducer;
